import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c45fbd4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__report-lesson px-10 md-down:px-4 pb-30" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-c45fbd4c><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 3.66797C1 3.11568 1.44772 2.66797 2 2.66797H14C14.5523 2.66797 15 3.11568 15 3.66797C15 4.22025 14.5523 4.66797 14 4.66797H2C1.44772 4.66797 1 4.22025 1 3.66797Z\" fill=\"#94A3B8\" data-v-c45fbd4c></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.33203 8C2.33203 7.44772 2.77975 7 3.33203 7H12.6654C13.2176 7 13.6654 7.44772 13.6654 8C13.6654 8.55228 13.2176 9 12.6654 9H3.33203C2.77975 9 2.33203 8.55228 2.33203 8Z\" fill=\"#94A3B8\" data-v-c45fbd4c></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33203 12C4.33203 11.4477 4.77975 11 5.33203 11H10.6654C11.2176 11 11.6654 11.4477 11.6654 12C11.6654 12.5523 11.2176 13 10.6654 13H5.33203C4.77975 13 4.33203 12.5523 4.33203 12Z\" fill=\"#94A3B8\" data-v-c45fbd4c></path></svg><div class=\"ml-1.5 font-semibold text-neutral-600\" data-v-c45fbd4c>Bộ lọc</div>", 2)
const _hoisted_6 = [
  _hoisted_4
]
const _hoisted_7 = { class: "w-full mb-10" }
const _hoisted_8 = { class: "border-b border-neutral-200" }
const _hoisted_9 = {
  "aria-label": "Tabs",
  class: "-mb-px flex space-x-8 tabs"
}
const _hoisted_10 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DaIcon, {
          name: "das--report",
          class: "mr-3 h-6 w-6"
        }),
        _createTextVNode(" Báo cáo cá nhân ")
      ]),
      _createElementVNode("div", {
        class: "w-30 bg-white p-3 rounded-md border shadow-sm border-neutral-200 cursor-pointer flex items-center",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerFilter && _ctx.triggerFilter(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("nav", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: tab.id,
              to: { name: tab.link },
              class: "border-transparent hover:text-yellow-700 hover:border-yellow-500 text-neutral-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_DaIcon, {
                      name: tab.icon,
                      class: "h-4 w-4"
                    }, null, 8, ["name"])
                  ]),
                  _createElementVNode("div", null, _toDisplayString(tab.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view, { openFilter: _ctx.openFilter }, null, 8, ["openFilter"])
    ])
  ]))
}